const MTM_PARAMS = [
  'mtm_campaign',
  'mtm_keyword',
  'mtm_kwd',
  'mtm_source',
  'mtm_medium',
  'mtm_content',
  'mtm_cid',
  'mtm_group',
  'mtm_placement'
]

const UTM_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'utm_id'
]

// Piwik legacy synonyms (officially pk_campaign / pk_kwd)
const PK_PARAMS = [
  'pk_source',
  'pk_medium',
  'pk_campaign',
  'pk_kwd',
  'pk_content',
  'pk_cid',
  'pk_group',
  'pk_placement'
]

const SYNONYMS_TO_MTM = {
  mtm_campaign: ['utm_campaign', 'pk_campaign'],
  mtm_kwd: ['utm_term', 'pk_kwd'],
  mtm_source: ['utm_source', 'pk_source'],
  mtm_medium: ['utm_medium', 'pk_medium'],
  mtm_content: ['utm_content', 'pk_content'],
  mtm_cid: ['utm_id', 'pk_cid'],
  mtm_group: ['pk_group'],
  mtm_placement: ['pk_placement']
}

export { MTM_PARAMS, UTM_PARAMS, PK_PARAMS, SYNONYMS_TO_MTM }
